var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Orig",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110px",
    height: "39px",
    viewBox: "0 0 110 39",
    style: {
      enableBackground: "new 0 0 110 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0656A5;}\n\t.st1{fill:#A7228C;}\n\t.st2{fill:#0B0B0B;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.3,30.4 29.7,30.4 14.9,15.6 1.1,15.6 23.5,38 51.8,38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.6,15.2 29.4,29 29.4,14.9 15.6,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45,15.9 45,30.1 52.6,37.7 52.6,23.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.1,32.7l-3.4,0v-7.8l-1.8-1.8H99l0,6.4l-3-3.1c-0.6-0.6-1.4-0.9-2.2-0.9c-1,0-1.9,0.5-2.5,1.2L90,25.5 h-4.5l-0.9,2.7l-2.7-2.7l-4.5,0l1.3,3.8l-2.8-2.8c-0.6-0.6-1.4-0.9-2.2-0.9c-1.4,0-2.6,0.9-3,2.2l-2.1,6.1l-1.1-1.1l-3.4,0v-7.8 l-1.8-1.8h-3.8v13.4l2.4,2.3l12.2,0l1.1-3.1H75l1.1,3.1l6,0l-0.9-2.6c1.2,1.2,2.5,3,4.4,2.6c1-0.2,1.9-1,2.4-1.8l1.9,1.8l3,0 l1.1-3.1H95l1.1,3.1H110v-4.1L108.1,32.7z M67.1,36.2H59V23.9h2.7v9.6l5.3,0V36.2z M76,36.2l-2.3-6.7L72.8,32h0.9l0.5,1.5h-2 l-0.9,2.7h-2.8l2.9-8.3c0.3-0.9,1.2-1.6,2.3-1.6c1,0,1.9,0.7,2.3,1.6l2.9,8.3H76z M86,34.6c-0.3,0.9-1.2,1.6-2.3,1.6 c-1,0-1.9-0.7-2.3-1.6l-2.9-8.3h2.8l2.3,6.7l2.3-6.7h2.8L86,34.6z M96,36.2l-0.9-2.7h-2l0.5-1.5h0.9l-0.9-2.5l-2.3,6.7h-2.8 l2.9-8.3c0.3-0.9,1.2-1.6,2.3-1.6c1,0,1.9,0.7,2.3,1.6l2.9,8.3H96z M107.8,36.2h-8.1V23.9h2.7v9.6l5.3,0V36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.4,14.8L15.6,0L0,0v15.6l23.2,23.2h30.2V23.2L45,14.8H30.4z M30.2,15.6h14v14h-14V15.6z M15.6,1.1 l13.8,13.8V29L15.6,15.2V1.1z M0.8,0.8h14.1v14.1H0.8V0.8z M23.5,38L1.1,15.6h13.8l14.8,14.8h14.6l7.6,7.6H23.5z M45,15.9l7.6,7.6 v14.2L45,30.1V15.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.8,23.9 59,23.9 59,36.2 67.1,36.2 67.1,33.5 61.8,33.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.7,26.3c-1,0-1.9,0.7-2.3,1.6l-2.9,8.3h2.8l0.9-2.7h2L73.7,32h-0.9l0.9-2.5l2.3,6.7h2.8l-2.9-8.3 C75.6,26.9,74.7,26.3,73.7,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.7,26.3c-1,0-1.9,0.7-2.3,1.6l-2.9,8.3h2.8l2.3-6.7l0.9,2.5h-0.9l-0.5,1.5h2l0.9,2.7h2.8L96,27.9 C95.6,26.9,94.7,26.3,93.7,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86,26.3L83.7,33l-2.3-6.7h-2.8l2.9,8.3c0.3,0.9,1.2,1.6,2.3,1.6c1,0,1.9-0.7,2.3-1.6l2.9-8.3H86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "102.5,33.5 102.5,23.9 99.8,23.9 99.8,36.2 107.8,36.2 107.8,33.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    className: "st3",
    width: 14.1,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 15.6,
    className: "st3",
    width: 14,
    height: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavalLogo);
export default __webpack_public_path__ + "static/media/laval-logo.6007aafc5dcb95e9f31d18f3aa8ff60a.svg";
export { ForwardRef as ReactComponent };